<template>
    <!--<a class="nav-link" :href="urlWishList" rel="nofollow">
        <span class="badge-right mr-1 d-none d-sm-inline">{{ wishListCount }}</span>
        <i class="fa" :class="{'fa-heart-o': !wishListCount, 'fa-heart': wishListCount}" aria-hidden="true"></i>
    </a>-->
    <a :href="urlWishList" rel="nofollow" :title="$translate('Ceres::Template.singleItemWishList')">
        <svg width="19" height="16" class="header-controls__icon"><use xlink:href="#svg_wishlist" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg>
        <span class="header-controls__item-badge" v-if="wishListCount > 0">{{ wishListCount }}</span>
    </a>
</template>

<script>
export default {
    computed:
    {
        wishListCount()
        {
            return this.$store.getters.wishListCount;
        },

        urlWishList()
        {
            return App.urls.wishList;
        }
    }
}
</script>
